import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DateAdapter, MatDialog, MatDialogRef, MAT_DATE_LOCALE, MAT_DIALOG_DATA, MatSnackBarConfig, MatSnackBar } from '@angular/material';
import { CedisService } from 'src/app/services/cedis.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { CustomDateAdapter } from 'src/app/utils/cutom.date.adapter';
import { MotivoCambioATQComponent } from './motivo-cambio-atq/motivo-cambio-atq.component';
import { ConfiguracionWebService } from 'src/app/services/configuracionWeb.service';
import { utils } from 'src/app/utils/utils';
import { map, startWith } from 'rxjs/operators';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-editar-pedido-atq',
  templateUrl: './editar-pedido-atq.component.html',
  styleUrls: ['./editar-pedido-atq.component.scss', '../../estilosModales.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-MX'},
    { provide: DateAdapter, useClass: CustomDateAdapter}]
})
export class EditarPedidoATQComponent implements OnInit {

  orgdes: any[] = [];
  pedido: any = {};

  fechaCliente: Date;
  horasCliente: any;
  minutosCliente: any;

  finFechaCliente: Date;
  finHorasCliente: any;
  finMinutosCliente: any;

  fechaCarga: any;
  horasCarga: any;
  minutosCarga: any;

  fechaDes: any;
  horasDes: any;
  minutosDes: any;

  idOrigen = null;
  idDestino = null;
  selectedTransporte = null;
  transportePreferente = [
    {val: 0, descripcion: 'Propio'},
    {val: 1, descripcion: 'Tercero'}
  ]

  usuarioSession: any;
  pedidosForm: FormGroup

  limitFechaCita: Date | null = null;
  limiteMaxFechaCita: Date | null = null;

  limiteFechaCargaMax: Date | null = null;
  limiteFechaCarga: Date | null = null;
  isConvenio = null
  paramATQDESPDIRECTO: any = false;//parametro de despacho. 
  public _utils:utils;
  orgFiltered;
  desFiltered;
  idOrigenSelected
  idDestinoSelected

  constructor(public dialogRef: MatDialogRef<EditarPedidoATQComponent>, private _cdis: CedisService, private _pedido: PedidoService,
    @Inject(MAT_DIALOG_DATA) public data, private formBuilder: FormBuilder, public dialog: MatDialog,
    private configuracionWebService: ConfiguracionWebService,
    public snackBar: MatSnackBar) {
    this.usuarioSession = JSON.parse(sessionStorage.getItem("usuario"));
    this._utils = new utils();
  }

  ngOnInit() {
    this.buildForm();
    this.consultarOrigenDestino();
    // this.consultarPedido();
    this.consultarDespDirecto();
  }

  consultarDespDirecto(){
    //Obtiene el parametro de configuracion de autoquimicos 
    this.configuracionWebService.consultarParametro(this.usuarioSession.idRazonSocial, "ATQDESPDIRECTO").subscribe(data => {
      if (data != null || data != undefined){
        if(data == "S"){
          this.paramATQDESPDIRECTO = true;
        }else{
          this.paramATQDESPDIRECTO = false;
        }
        console.log('paramATQDESPDIRECTO-> ',this.paramATQDESPDIRECTO);
      }      
    }), error => console.error(error);
  }

  buildForm() {
    this.pedidosForm = this.formBuilder.group({
      fechaCliente: this.formBuilder.control({value:null, disabled: this.data.isDisabled}, [Validators.required]),
      horasCliente: this.formBuilder.control({value:null, disabled: this.data.isDisabled}, [Validators.required]),
      minutosCliente: this.formBuilder.control({value:null, disabled: this.data.isDisabled}, [Validators.required]),

      finFechaCliente: this.formBuilder.control({value:null, disabled: this.data.isDisabled}, [Validators.required]),
      finHorasCliente: this.formBuilder.control({value:null, disabled: this.data.isDisabled}, [Validators.required]),
      finMinutosCliente: this.formBuilder.control({value:null, disabled: this.data.isDisabled}, [Validators.required]),

      fechaCarga: this.formBuilder.control({value:null, disabled: this.data.isDisabled}, [Validators.required]),
      horasCarga: this.formBuilder.control({value:null, disabled: this.data.isDisabled}, [Validators.required]),
      minutosCarga: this.formBuilder.control({value:null, disabled: this.data.isDisabled}, [Validators.required]),

      fechaDes: this.formBuilder.control({value:null, disabled: this.data.isDisabled}, [Validators.required]),
      horasDes: this.formBuilder.control({value:null, disabled: this.data.isDisabled}, [Validators.required]),
      minutosDes: this.formBuilder.control({value:null, disabled: this.data.isDisabled}, [Validators.required]),

      origen: this.formBuilder.control({value:null, disabled: this.data.isDisabled}, [Validators.required]),
      destino: this.formBuilder.control({value:null, disabled: this.data.isDisabled}, [ Validators.required]), 
      
      transporte: this.formBuilder.control({value:null, disabled: this.data.isDisabled}, []) 
    });    
        
  }

  filterPlazaOrigen(val:string):any[]{
    const filterValue = val.toLowerCase();
    const x = this.orgdes.filter(orgdes => orgdes.nombre.toLocaleLowerCase().indexOf(filterValue) === 0);
    return this.orgdes.filter(orgdes => orgdes.nombre.toLocaleLowerCase().indexOf(filterValue) === 0)
  }

  consultarOrigenDestino() {
    this._cdis.consultarPedidosCedis(this.usuarioSession.idRazonSocial, 2).subscribe(
      result => {
        if(result != null){
          this.orgdes = result;        
          this.orgFiltered = this.pedidosForm.get('origen').valueChanges.pipe(startWith(''), map(origen => origen ? this.filterPlazaOrigen(origen) : this.orgdes.slice()));
          this.desFiltered = this.pedidosForm.get('destino').valueChanges.pipe(startWith(''), map(origen => origen ? this.filterPlazaOrigen(origen) : this.orgdes.slice()));
        }
      },
      error => {
        console.log(error);
      },
      () => {
        this.consultarPedido();
      }
    );
  }

  consultarPedido() {
    let param = {
      idRazonSocial: this.usuarioSession.idRazonSocial,
      idPedido: this.data.idPedido
    }
    this._pedido.consultarPedidoSolicitud(param).subscribe(
      result => {
        this.fechaCarga = new Date(result[0].inicioDescarga);
        this.horasCarga = this.fechaCarga.getHours();
        this.minutosCarga = this.fechaCarga.getMinutes();

        this.fechaDes = new Date(result[0].finDescarga);
        this.horasDes = this.fechaDes.getHours();
        this.minutosDes = this.fechaDes.getMinutes();

        this.fechaCliente = new Date(result[0].inicioCarga);
        this.horasCliente = this.fechaCliente.getHours();
        this.minutosCliente = this.fechaCliente.getMinutes();

        this.finFechaCliente = new Date(result[0].finCarga);
        this.finHorasCliente = this.finFechaCliente.getHours();
        this.finMinutosCliente = this.finFechaCliente.getMinutes();

        this.idOrigen = this.orgdes.find(x => x.idCedis == result[0].idOrigenPlaza).nombre //result[0].idOrigenPlaza;
        this.idDestino = this.orgdes.find(x => x.idCedis == result[0].idDestinoPlaza).nombre //result[0].idDestinoPlaza;
        this.idOrigenSelected = result[0].idOrigenPlaza;
        this.idDestinoSelected = result[0].idDestinoPlaza;
        this.selectedTransporte = result[0].transportePreferente;
        
        this.isConvenio = result[0].idEmbarqueConvenio;
        

        this.setfechaCita();
        this.setfechaCarga();
      },
      error => {
        console.log(error);
      }
    );
  }

  guardar() {
    if(this.pedidosForm.valid) {
      if(this.selectedTransporte != null){
        this.motivoCambio();
      }else {
        this.guardarCambios(null);
      }
    }
  }

  guardarCambios(motivo) {
    this.fechaCliente.setHours(this.horasCliente, this.minutosCliente);
    this.fechaCarga.setHours(this.horasCarga, this.minutosCarga);
    this.fechaDes.setHours(this.horasDes, this.minutosDes);
    this.finFechaCliente.setHours(this.finHorasCliente, this.finMinutosCliente);

    this.pedido.fechaEntrega = moment(this.fechaCliente).format('YYYY-MM-DDTHH:mm:ss');    
    this.pedido.inicioCarga = moment(this.fechaCliente).format('YYYY-MM-DDTHH:mm:ss');
    this.pedido.inicioDescarga = moment(this.fechaCarga).format('YYYY-MM-DDTHH:mm:ss');
    this.pedido.finCarga = moment(this.finFechaCliente).format('YYYY-MM-DDTHH:mm:ss');
    this.pedido.finDescarga = moment(this.fechaDes).format('YYYY-MM-DDTHH:mm:ss');

    this.pedido.idOrigen = this.idOrigenSelected//this.idOrigen;
    this.pedido.idDestino = this.idDestinoSelected//this.idDestino;
    this.pedido.idPedido = this.data.idPedido;
    this.pedido.transportePreferente = this.selectedTransporte;
    this.pedido.motivoCambioTransporte = motivo;
    this.pedido.realizoCambioTransporte = motivo? this.usuarioSession.idUsuario : null

    this.editarPedido();
  }

  editarPedido() {
    this.pedido.idRazonSocial = this.usuarioSession.idRazonSocial;
    // this.pedido.idRazonSocial = 1035;
    this.pedido.activoZAM = this.paramATQDESPDIRECTO ? 0 : this.usuarioSession.activoZAM;

    const fechaCarga = new Date(this.fechaCliente);    
    fechaCarga.setHours(this.horasCliente, this.minutosCliente, 0, 0);

    const fechaCargaFin = new Date(this.finFechaCliente);    
    fechaCargaFin.setHours(this.finHorasCliente, this.finMinutosCliente, 0, 0);

    const fechaDescarga = new Date (this.fechaCarga);    
    fechaDescarga.setHours(this.horasCarga, this.minutosCarga, 0, 0);

    const fechaDescargaFin = new Date (this.fechaDes);    
    fechaDescargaFin.setHours(this.horasDes, this.minutosDes, 0, 0);
    
    if(
      fechaDescarga < fechaCarga ||
      fechaDescarga < fechaCargaFin ||
      fechaDescargaFin < fechaCarga ||
      fechaDescargaFin < fechaCargaFin
    ){
      this._utils.toast('Las fechas son incorrectas!',this.snackBar);
      return;
    }

    if(
      fechaCargaFin <= fechaCarga ||
      fechaDescargaFin <= fechaDescarga
    ){
      this._utils.toast('Las fechas son incorrectas!',this.snackBar);
      return;
    }
    
    this._pedido.editarPedido(this.pedido).subscribe(
      result => {
        this._utils.toast('El registro se actualizo exitosamente!',this.snackBar);        
        this.cerrarModal(true);
      },
      error => {
        console.log(error);
      }
    );
  }

  motivoCambio() {
    const dialogRef = this.dialog.open(MotivoCambioATQComponent, 
    {
      width: '30%',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(
      result => {
        if(result.respuesta){
          this.guardarCambios(result.motivo);
        }
      }
    );
  }

  cerrarModal(actualizar: boolean = false) {
    this.dialogRef.close(actualizar);
  }

  setfechaCita(){
    if(this.fechaCliente){
      this.limitFechaCita = new Date(this.fechaCliente);
      this.limiteMaxFechaCita = new Date(this.fechaCliente)
      this.limiteMaxFechaCita.setDate(this.limiteMaxFechaCita.getDate() + 2)
    }
  }

  setfechaCarga(){
    if(this.fechaDes){
      this.limiteFechaCarga = new Date(this.fechaDes);
      this.limiteFechaCargaMax = new Date(this.fechaDes);
      this.limiteFechaCargaMax.setDate(this.limiteFechaCargaMax.getDate() + 2)
    }
  }

}
